export const REFERRAL_REWARD_REACHED_TEST_ID = {
  modal: 'referral-reward-reached-modal',
  container: 'referral-reward-reached-container',
  animatedBackground: 'referral-reward-reached-animated-background',
  wrapper: 'referral-reward-reached-wrapper',
  preTitle: 'referral-reward-reached-pre-title',
  title: 'referral-reward-reached-title',
  subtitle: 'referral-reward-reached-subtitle',
  gradientBorder: 'referral-reward-reached-gradient-border',
  imageContainer: 'referral-reward-reached-image-container',
  image: 'referral-reward-reached-image',
  description: 'referral-reward-reached-description',
  swagRewardContainer: 'referral-reward-reached-swag-reward-container',
  swagRewardTitle: 'referral-reward-reached-swag-reward-title',
  swagRewardInput: 'referral-reward-reached-swag-reward-input',
  swagRewardButton: 'referral-reward-reached-swag-reward-button'
} as const
